import React, { useState, useEffect } from 'react';
import {
    Tabs, TabList, TabPanels, Tab, TabPanel, Image, Box, Text, Flex, SimpleGrid, useDisclosure,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    Button
} from '@chakra-ui/react'
import { StyleSheet, css } from 'aphrodite';
// import { seminarDetails } from './SeminarDetails';
import { useSelector, useDispatch } from "react-redux";
import { fetchData } from 'actions/actions';

import { seminarDetails } from './SeminarDetails';

function Description() {
  const isMobile = useSelector(state=> state.windowSize.isMobile)


  const { isOpen, onOpen, onClose } = useDisclosure()
  const dispatch = useDispatch();

  useEffect(() => {
      // Dispatch the fetchData action when the component mounts
      dispatch(fetchData());
    }, [dispatch]); 

  const [selectedImage, setSelectedImage] = useState(null);
  const openModalWithImage = (imageSrc) => {
      setSelectedImage(imageSrc); // Set the image based on the clicked card
      onOpen();
  };

  const isFutureDate = (dateStr) => {
    const seminarDate = new Date(dateStr);
    const today = new Date();

    seminarDate.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);

    return seminarDate >= today;
    };

  return (
    <>
    
    <Box className={css(styles.textbox)} textAlign={isMobile ? 'center' : 'left'}>
      <Flex className={css(styles.container)}>
        SITE-CAV SEMINAR
      </Flex>
      <b>The SITE-CAV seminar</b> series delve into a wide range of topics, including the latest advancements in 
      research, technology commercialization, and entrepreneurship in the field of Secure and Trustworthy CAVs. 
      These seminars feature experts and industry professionals, offering participants a unique opportunity to gain 
      insights into cutting-edge innovations, explore real-world applications, and engage in meaningful discussions. 
      Beyond knowledge-sharing, the series aim to foster collaboration between academia, industry, and policymakers, 
      creating a dynamic environment for networking, interdisciplinary exchange, and the advancement of next-generation 
      technologies.
    </Box>
    <hr />


    {seminarDetails ? (
    <>
        {/* Page Wrapper (80% width) */}
        <Box maxW="80%" mx="auto">


        {/* Seminar Grid */}
        <Box pt={4} pb={12}>
            <SimpleGrid
            columns={isMobile ? 1 : 3}
            spacing={10}
            justifyContent="center"
            >
            {seminarDetails.map((content, index) => (
                <Box
                className={css(styles.card)}
                onClick={() => openModalWithImage(content.image)}
                key={index}
                >
                <Text
                className={css(styles.subtitle)}
                color={isFutureDate(content.date) ? "red.500" : "black.600"}
                >
                    {content.title}
                </Text>

                <Text
                className={css(styles.subtitle)}
                color={isFutureDate(content.date) ? "red.500" : "black.600"}
                >
                    {content.date}
                    {isFutureDate(content.date) && (
                    <Text as="span" fontWeight="bold" ml={2}>
                        (upcoming)
                    </Text>
                    )}
                </Text>

                <Flex justifyContent="center">
                    <hr style={{ width: "50%", borderWidth: "2px" }} />
                </Flex>

                <Text
                className={css(styles.subtitle)}
                color="black.600"
                >
                    {content.address}
                </Text>

                <Text
                    fontSize="sm"
                    mt={3}
                    textAlign="center"
                    color="blue.500"
                    fontStyle="italic"
                    >
                    Click for more information
                </Text>

                </Box>
            ))}
            </SimpleGrid>

            {seminarDetails.length === 0 && (
            <Text
                textAlign="center"
                width="100%"
                fontWeight="bold"
                mt={8}
            >
                Exciting Seminars Coming Soon, Stay Tuned!
            </Text>
            )}
        </Box>
        </Box>
    </>
    ) : (
    <Flex minH="50vh" align="center" justify="center">
        Loading...
    </Flex>
    )}

    {/* Modal */}
    <Modal isOpen={isOpen} onClose={onClose} isCentered size="3xl" allowPinchZoom>
    <ModalOverlay />
    <ModalContent>
        {selectedImage && (
        <>
            <ModalHeader>About our host</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
            <Image src={selectedImage} alt="Seminar" width="100%" />
            </ModalBody>

            <ModalFooter>
            <Button colorScheme="red" mr={3} onClick={onClose}>
                Close
            </Button>
            </ModalFooter>
        </>
        )}
    </ModalContent>
    </Modal>






    </>
  )
}

const styles = StyleSheet.create({
    container: {
        maxWidth: '100%',
        justifyContent: 'center',
        fontSize: 24,
        margin: '2%',
        fontWeight: 'bolder',
        textShadow: '1px 1px gray',
        marginTop: 140,
        marginBottom:5
        
    },
    textbox: {
      margin: '3%',
      marginTop: 10,
      marginBottom: 25,
      textAlign: 'justify',
      fontSize: 18,
  },
  tabParent: {
    fontSize: 20,
    fontWeight: 'bold',
    color: '#DC242C'
  },
  heading: {
      fontWeight: 'bold',
      // fontSize: '24',
      textAlign: 'center',
      marginTop: 5,
      // backgroundColor: 'gray',
      // borderRadius: '25%',
      // color: 'white',
      // padding: '5%'
  },
  subtitle: {
      fontSize: '20',
      textAlign: 'center',
      marginTop: 5,
      fontWeight: 'bold',
      bottom: 0
  },
  card: {
      borderWidth: '1px',
      borderRadius: '5px',
      borderColor: 'gray',
      justifyContent: 'center',
      textAlign: 'center',
      alignContent: 'center',
      ':hover': {
        cursor: 'pointer'  
      },
      // position: 'relative'
  },
  dateCircle: {
      position: 'absolute',
      bottom: 75,
      left: '50%', // Adjust as needed for positioning
      transform: 'translateX(-50%)',
      width: '10%',
      height: '10%',
      borderRadius: '50%',
      backgroundColor: 'black', // Change color as needed
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1, // Ensure the circle is above the image
    },
  dateText: {
    color: 'white',
    fontSize: '16',
    // fontWeight: 'bold',
    // Adjust text styles as needed
  },



})

export default Description